var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
export default function createIcon(iconConfig) {
  var Icon = function Icon(_a) {
    var bgStyle = _a.bgStyle,
        borderRadius = _a.borderRadius,
        iconFillColor = _a.iconFillColor,
        round = _a.round,
        size = _a.size,
        rest = __rest(_a, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);

    return React.createElement("svg", __assign({
      viewBox: "0 0 64 64",
      width: size,
      height: size
    }, rest), round ? React.createElement("circle", {
      cx: "32",
      cy: "32",
      r: "31",
      fill: iconConfig.color,
      style: bgStyle
    }) : React.createElement("rect", {
      width: "64",
      height: "64",
      rx: borderRadius,
      ry: borderRadius,
      fill: iconConfig.color,
      style: bgStyle
    }), React.createElement("path", {
      d: iconConfig.path,
      fill: iconFillColor
    }));
  };

  Icon.defaultProps = {
    bgStyle: {},
    borderRadius: 0,
    iconFillColor: 'white',
    size: 64
  };
  return Icon;
}